import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isBasicComponentType'
})
export class IsBasicComponentTypePipe implements PipeTransform {

    transform(type: string, ...args: unknown[]): boolean {
        switch (type) {
            case 'p':
            case 'section':
            case 'single_select':
            case 'text_input':
            case 'email_input':
            case 'date_input':
            case 'date_from_and_to':
            case 'number_input':
            case 'rate_input':
            case 'multi_select':
            case 'checklist':
            case 'divider':
                return true;
            default:
                return false;
        }
    }

}
